import { VenueCreateShopifyStoreInput } from '../../graphql/API';
import { venueCreateShopifyStoreConnection } from '../../graphql/mutations';
import { executeGql } from '../../utils/gql-utils';

export const venueCreateShopifyStoreConnectionApi = async (
  input: VenueCreateShopifyStoreInput,
): Promise<void> => {
  await executeGql(venueCreateShopifyStoreConnection, { input });
};
